// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import { getTheme } from 'settings/theme/index';
import Tag from 'components/Tag/index';
import SimpleCard from 'components/SimpleCard/index';
import UserTag from 'components/UserTag/index';

const {
  palette: { greyscale },
  noodera: { fontTypes, spacing },
} = getTheme();
export const SwipeWrapper: StatelessFunctionalComponent<any> = styled.div`
  && {
    margin-left: 28px;

    & > .my-carousel {
      & > button {
        background: transparent;

        &:first-of-type {
          left: -4rem;
        }
        &:last-of-type {
          right: -1rem;
        }
      }

      & > div {
        padding: 0;

        & > div {
          & > div & > div {
            width: 100%;
          }
        }
      }
    }
  }
`;
export const StyledSimpleCard: StatelessFunctionalComponent<any> = styled(SimpleCard)`
  display: flex;
  flex-direction: column;
  width: 99%;
  height: 344px;
  background: ${getTheme().gradients.noodera};

  & > * {
    display: flex;
    flex-grow: 1;
  }
`;
export const StyledTag: StatelessFunctionalComponent<any> = styled(Tag)`
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid ${greyscale.white};
  border-radius: 12px;
  width: 58px;
  height: 24px;
  max-height: 24px;
  color: ${greyscale.white};
`;
export const SimpleCardContent: StatelessFunctionalComponent<any> = styled.div`
  && {
    flex-direction: column;
    color: ${greyscale.white};
    padding: ${spacing.x5} 0;
    background: transparent;

    & > span:first-child {
      ${fontTypes.font4Medium};
    }

    & > span {
      ${fontTypes.font4};
      margin-bottom: ${spacing.x8};
    }
  }
`;
export const SimpleCardTag: StatelessFunctionalComponent<any> = styled(UserTag)`
  && {
    margin-top: ${spacing.x5};
    max-height: 48px;

    & > div:last-child {
      & > * {
        color: ${greyscale.white};
      }

      & > p {
        ${fontTypes.font4Medium};
      }

      & > div {
        ${fontTypes.font5};
      }
    }
  }
`;
export const SimpleCardButton: StatelessFunctionalComponent<any> = styled.div`
  && {
    align-items: flex-end;
    max-height: 48px;

    & > .btn {
      ${fontTypes.font4Medium};
      display: flex;
      justify-content: center;
      align-items: center;
      width: 127px;
      height: 48px;
      padding: 0;

      & > svg {
        font-size: 16px;
        margin-right: ${spacing.x6};
      }
    }
  }
`;
